<template>
	<!-- footer-->
	<div class="footer">
		<div class="columnasContenedor">
			<div class="columna">
				<div class="log">
					<router-link :src="logo" tag="img" to="/"></router-link>
				</div>
			</div>

			<div class="columna">
				<div class="header">
					<h3>PHONE</h3>
				</div>
				<div>
					<!-- CONTACT LINE: -->
					<!-- <br>01 800 215 3103 -->
					<h3>+52 1 55 5407 7599</h3>
				</div>
			</div>

			<div class="columna">
				<div class="header">
					<h3>MENU</h3>
				</div>

				<div class="columna menuFooter">
					<ul id="nav">
						<router-link tag="li" to="/" exact>
							<a class>home</a>
						</router-link>
						<router-link tag="li" to="/about">
							<a class>
								about
								<span class="spanMenu">us</span>
							</a>
						</router-link>

						<li>
							<a @click="isShowSubmenu" :class="{ activeFooter: areWeinServicesFooter }">services</a>
							<ul class="submenu" v-if="showSubmenu">
								<router-link v-for="(item, idx) in menuItems" tag="li" :to="{name: item.route}" :key="idx">
									<a>{{item.label}}</a>
								</router-link>
							</ul>
						</li>
						<router-link tag="li" to="/contact">
							<a class>
								Contact
								<span class="spanMenu">us</span>
							</a>
						</router-link>
					</ul>
				</div>
			</div>

			<div class="columna">
				<!-- Esto queda temporalmente invisible -->
				<!--
				<div class="header">
						<h3>
								Follow Us
						</h3>
				</div>

				<div class="iconos">
						<ul>
								<li>
										<a href="https://www.facebook.com/Grupo-Glarus-434773643370328/">
												<img src="../assets/img/facebook.png">
										</a>
								</li>
								<li>
										<a href="https://www.linkedin.com/in/grupo-glarus-828096b9">
												<img src="../assets/img/linkedin.png">
										</a>
								</li>
								<li>
										<a href="#">
												<img src="../assets/img/twitter.png">
										</a>
								</li>
						</ul>
				</div>

				-->
			</div>
		</div>
		<div class="pie">Todos los Derechos Reservados Grupo Glarus © {{currentYear}}</div>
	</div>

	<!--fin footer -->
</template>

<script>
import logoAzul from "../assets/img/logos/logo_glarus_white.png";
import menuItems from "@/components/menu-items.js";

export default {
	name: "FooterComponent",
	data: function() {
		return {
			logo: logoAzul,
			showSubmenu: false,
			menuItems: menuItems,
			currentYear: null
		};
	},
	props: ["areWeinServicesFooter"],

	mounted() {
		this.$nextTick(() => {});
		let d = new Date();
		this.currentYear = d.getFullYear();

	},
	methods: {
		isShowSubmenu() {
			this.showSubmenu = !this.showSubmenu;
		}
	}
};
</script>

<style scoped lang="less" >
@import url("../assets/less/soloVariables.less");

.spanMenu {
	padding-left: 5px;
}

.footer {
	position: relative;
	background-color: #648175;
	width: 100%;

	.columnasContenedor {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		justify-items: center;
		flex-wrap: wrap;

		.columna {
			//Este width funciona para 4 columnas width: 300px;
			width: 300px; // esto funciona para 3 en desktop
			font-size: 0.8em;
			line-height: 1.8em;
			padding: 10px 30px;

			.router-link-active {
				background-color: darken(@color_Secundario_Logo, 2);
				padding: 0px 5px;
				// padding-right: 90%;
			}

			@media (max-width: 920px) {
				padding: 10px 30px;
				flex: 1 1 100%;
			}

			p {
				width: 80%;
				font-size: 1.1em;
				@media (max-width: @limiteAnchoTablet) {
					width: 60%;
				}
			}
			p .headerFollow {
				padding-left: 20px;
			}

			.header {
				h3 {
					width: 100px;
					font-size: 1.1em;
					text-transform: uppercase;
				}
			}

			.iconos {
				ul {
					list-style: none;
					margin: 0px;
					padding: 0px;

					li {
						display: inline-block;
						padding: 0px;
						img {
							width: 20px;
							padding-right: 15px;
						}
					}
				}
			}

			.log {
				cursor: pointer;
				padding-top: 5px;
				width: 200px;
				//border: 2px solid white;
				.router-link-active {
					background-color: rgba(0, 0, 0, 0);
					padding: 0px 0px;
					padding-right: 0%;
				}
				@media (max-width: @limiteAnchoTablet) {
					width: 250px;
				}
			}

			.menuFooter {
				width: 100%;
				a {
					cursor: pointer;
				}
				.submenu {
					font-size: 0.8em;
					line-height: 1.5em;
					width: 100%;
					li {
						padding: 8px 5px;
						margin: 5px 0px;
					}
				}

				padding: 0px;
				ul {
					list-style: none;
					padding: 0px;

					li {
						text-transform: uppercase;

						a {
							font-size: 1.5em;
							line-height: 2em;
							padding-top: 3px;
							padding-bottom: 3px;
							color: rgb(219, 215, 215);
						}
						.activeFooter {
							background-color: darken(@color_Secundario_Logo, 2);
							margin-left: 5px;
							padding: 5px;
							font-weight: bold;
						}

						a:hover {
							color: #003b57;
						}
					}
				}
			}
		}
	}

	.pie {
		height: 20px;
		padding: 30px 0px 20px 40px;
		letter-spacing: 1.5px;
		font-size: 0.7em;
		color: lightgray;
		background-color: #5a7066;
		@media (max-width: @limiteAnchoTablet) {
			text-align: center;
			padding: 30px 10px 20px 10px;
		}
	}
}
</style>
